import React, { Component } from "react";
import TableInvest from '../components/intable.js';
 
class Trades extends Component {
  render() {
    return (
      <div>
        <div className="row">
        <h2>Twitter Feeds</h2>
        <p>Twitter is often considered where information will hit first.
            Twitter users are also notorious for having strong opinions on current events.
            Taking both of these things into consideration, our trading algorithm
            uses the emotional conotation of Twitter users tweets about certain current events.
        </p>
        </div>
        <div className="row">
        <h2>Company Profit Loss Ration</h2>
        <p>Every quarter, each public company is required to publish their profits and losses for that quarter.
          This profit / loss statement greatly affects the market, because when a company makes alot of money, people
          consider the company a good investment and the stock a good buy, and will invest raising the price. Alternatively, if a company losses money
          over the quarter, investors sell off that companies stock assuming it is a bad buy, lowering the price.
        </p>
        </div>
        <div className="row">
        <h2>200 Day Moving Average</h2>
        <p>
          "A body in motion stays in motion, unless acted upon by an outside force." We believe that Newton's Law comes into play for the stock market too. If a
          stock is trending upwards and has a high 200-day moving average, odds are, that trend will continue and the price of that stock will rise. If the 200-day moving average is
          low or negative, then that trend is also assumed to continue, and the price of that stock will continue to fall.
        </p>
        </div>
        <TableInvest />
      </div>
      
    );
  }
}
 
export default Trades;